<div>
    <app-spinner *ngIf="loading"></app-spinner>
    <div *ngIf="validateProductAssurance()"></div>
    <div class="row">
        <div class="col-12  my-3">
            <span class="validationTitle muted-color"> {{ 'SERVICE_VALIDATION.LABEL1' | translate }} </span>
        </div>
        <div class="col-12">
            <span class="validationText muted-color"> {{ 'SERVICE_VALIDATION.LABEL2' | translate }} </span>
        </div>
    </div>
    <div *ngFor="let question of questionSetItem?.Questions; let i = index">
        <div *ngIf="question" (onCreate)="addQuestion(question)"></div>
    </div>
    <mat-card class="sideCard">
        <ng-container *ngIf="formGroup">
            <form [formGroup]='formGroup' novalidate>
                <div formArrayName="questions" *ngFor="let question of questions.controls; let i = index">
                    <div class="row" *ngIf="questions.controls[i].get('type')?.value == '1' && (i > 2) "
                        [formGroupName]="i">
                        <div class="col-12">
                            <span class="serviceDataText">{{questions.controls[i].get('text')?.value}}</span>
                        </div>
                        <div class="col-4 col-sm-4 col-md-2">
                            <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                                <mat-label> {{ 'SERVICE_VALIDATION.LABEL3' | translate }} </mat-label>
                                <mat-select formControlName="day">
                                    <mat-option [value]="day" *ngFor="let day of days">{{day}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-4 col-sm-4 col-md-2">
                            <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                                <mat-label> {{ 'SERVICE_VALIDATION.LABEL4' | translate }} </mat-label>
                                <mat-select formControlName="month">
                                    <mat-option [value]="month" *ngFor="let month of months">{{month}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-4 col-sm-4 col-md-2">
                            <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                                <mat-label> {{ 'SERVICE_VALIDATION.LABEL5' | translate }} </mat-label>
                                <mat-select formControlName="year">
                                    <mat-option [value]="year" *ngFor="let year of years">{{year}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6"></div>
                    </div>
                    <div class="row" *ngIf="questions.controls[i].get('type')?.value == '2'  && (i > 2)"
                        [formGroupName]="i">
                        <div class="col-12">
                            <span class="serviceDataText">{{questions.controls[i].get('text')?.value}}</span>
                        </div>
                        <div class="col-12">
                            <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                                <textarea maxlength="500" matInput placeholder=""
                                    formControlName="description"></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row" [formGroupName]="i" onCreate="questionCreate()"
                        *ngIf="questions.controls[i].get('type')?.value == '3' && questions.controls[i].get('index')?.value && questions.controls[questions.controls[i].get('index')?.value].get('multiple')?.value == questions.controls[i].get('value')?.value && (i > 2) ">
                        <div class="col-12">
                            <span class="serviceDataText">{{questions.controls[i].get('text')?.value}}</span>
                        </div>
                        <div class="col-12">
                            <mat-radio-group color="primary" class="radio-group-vertical" formControlName="multiple">
                                <mat-radio-button value="Yes"> {{ 'SERVICE_VALIDATION.LABEL6' | translate }} </mat-radio-button>
                                <mat-radio-button value="No"> {{ 'SERVICE_VALIDATION.LABEL7' | translate }} </mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row"
                        *ngIf="questions.controls[i].get('type')?.value == '3' && !questions.controls[i].get('index')?.value && (i > 2) "
                        [formGroupName]="i">
                        <div class="col-12">
                            <span class="serviceDataText">{{questions.controls[i].get('text')?.value}}</span>
                        </div>
                        <div class="col-12">
                            <mat-radio-group color="primary" class="radio-group-vertical" formControlName="multiple">
                                <mat-radio-button value="Yes"> {{ 'SERVICE_VALIDATION.LABEL6' | translate }} </mat-radio-button>
                                <mat-radio-button value="No"> {{ 'SERVICE_VALIDATION.LABEL7' | translate }} </mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </div>
            </form>
        </ng-container>

    </mat-card>
    <div *ngIf="questions.controls[5]?.get('multiple')?.value == 'Yes' && validateProductAssurance(); else elseBlockQuestion"
        (onCreate)="isDocument(true)"></div>
    <div class="row mt-2"
        *ngIf="questions.controls[5]?.get('multiple')?.value == 'Yes' && validateProductAssurance();">
        <mat-card>
            <mat-card-content>
                <div>
                    <h6>
                        {{ 'SERVICE_VALIDATION.LABEL8' | translate }} 
                    </h6>
                    <h6>
                        {{ 'SERVICE_VALIDATION.LABEL9' | translate }} 
                    </h6>
                </div>
                <div class="mt-3">
                    <mat-label> {{ 'SERVICE_VALIDATION.LABEL10' | translate }} </mat-label>
                </div>
                <div class="col-12 col-sm-12 col-md-4">
                    <label class="mat-focus-indicator p-2 w-100 mat-stroked-button mat-button-base mat-primary"
                        for="file-input">
                        <fa-icon [icon]="faUpload" class="primary-color"></fa-icon> {{ 'SERVICE_VALIDATION.LABEL11' | translate }} 
                    </label>
                    <input id="file-input" type="file" accept=".pdf,.jpg,.PNG,.png,.JPEG"
                        (change)="readFile($event)" />
                </div>
                <div class="mt-2">
                    <mat-label class="text-muted" *ngIf="file">{{file.name}}</mat-label><br>
                    <mat-label class="text-muted"> {{ 'SERVICE_VALIDATION.LABEL12' | translate }} </mat-label>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
    <ng-template #elseBlockQuestion >
        <div (onCreate)="isDocument(false)"></div>
    </ng-template>
    <div class="d-none d-sm-none d-md-flex justify-content-end my-5">
        <button class="w-25 p-1" type="button" [disabled]="isDisabledBack" (click)="stepBack()" mat-raised-button
            color="accent">
            {{ 'SERVICE_VALIDATION.LABEL13' | translate }} 
        </button>
        <button class="w-25 p-1 mx-2" type="submit" [disabled]="isDisabled" (click)="stepOn()" mat-raised-button
            color="primary">
            {{ 'SERVICE_VALIDATION.LABEL14' | translate }} 
        </button>
    </div>
    <div class="d-block d-sm-block d-md-none">
        <mat-card class="serviceCard my-3">
            <mat-card-content>
                <button class="w-100 p-1 mx-2" type="submit" [disabled]="isDisabled " (click)="stepOn()"
                    mat-raised-button color="primary">
                    {{ 'SERVICE_VALIDATION.LABEL14' | translate }} 
                </button>
            </mat-card-content>
        </mat-card>
    </div>
</div>